import login from "./login";
import refreshToken from "./refreshToken";

const authServices = {
  login,
  refreshToken,
};

export default authServices;
